import type { AgentId, CardPushEnvelope } from '@voll-intelligence/domain';
import type { SseClient } from '@web/data/services';

export interface RealtimeRepository {
  /** Subscribes to live kanban board updates for the org; returns unsubscribe. */
  subscribeKanban: (
    orgId: string,
    handlers: {
      onEnvelope: (envelope: CardPushEnvelope) => void;
      /** The viewer's own agent id (null when none), sent once on connect. */
      onHello?: (agentId: AgentId | null) => void;
    },
  ) => () => void;
}

export function createRealtimeRepository(sseClient: SseClient): RealtimeRepository {
  return {
    subscribeKanban: (orgId, handlers) => sseClient.subscribeOrgEvents(orgId, handlers),
  };
}
